<template lang="pug">
#tabela-gestao-contrato-originacao-empresa
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('gestao-alvorada', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
            ref='multipleTable',
            @selection-change='handleSelectionChange'
        )
            el-table-column(
                type='selection',
                :selectable='camposSelecionaveis',
                v-if='removendo',
                align='center'
            )

            el-table-column(
                prop='numeroContrato',
                label='Nº do contrato',
                align='left',
                sortable,
                min-width='10'
            )
            el-table-column(
                prop='materialNome',
                label='Cultura',
                sortable,
                min-width='10'
            )
            el-table-column(
                prop='safraNome',
                label='Safra',
                sortable,
                min-width='7.5'
            )
            el-table-column(
                prop='volumeContratado',
                label='Volume vendido (t)',
                sortable='custom',
                min-width='10'
            )
                .template(slot-scope='scope')
                    span {{ scope.row.volumeContratado + ' t' }}
            el-table-column(
                prop='dataContrato',
                label='Data do contrato',
                sortable,
                min-width='10'
            )
            el-table-column(
                prop='clienteNomeRazaoSocial',
                label='Cliente',
                sortable,
                min-width='12.5'
            )
            el-table-column(
                prop='subEmpresaNome',
                label='Filial',
                sortable,
                min-width='12.5'
            )
            el-table-column(
                prop='statusEmpresa',
                label='Status',
                sortable,
                align='left',
                min-width='7.5'
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusEmpresa }}
                    .status-processamento__dias(v-if='scope.row.dataHa')
                        i.mdi.mdi-clock-outline
                        | {{ scope.row.dataHa }}

            el-table-column(label='Ações', align='center', min-width='5')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.visualizarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "NAO_VISUALIZADO" || scope.row.statusEmpresaCodigo === "VISUALIZADO"',
                                @click.native='editarContrato(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-square-edit-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.editarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo !== "ARQUIVADO" && scope.row.statusEmpresaCodigo !== "CONCLUIDO"',
                                @click.native='arquivarContrato(scope.row.id)'
                            )
                                i.mdi.mdi-archive
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.arquivar') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "CONCLUIDO"',
                                @click.native='exportarRelatorioRastreabilidade(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-file-download-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.exportarRelatorioRastreabilidade') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "CONCLUIDO"',
                                @click.native='exibirModalCompartilhamentoRelatorioRastreabilidade(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-share-variant-outline
                                span Compartilhar relatório de rastreabilidade
                            el-dropdown-item(
                                @click.native='removerContrato(scope.row)',
                                v-if='codigosRemover[scope.row.statusEmpresaCodigo]'
                            )
                                i.mdi.mdi-trash-can-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.removerContrato') }}
            template(slot='empty')
                el-empty(
                    :description='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.semDados")'
                )

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ paginacao.total }} {{ paginacao.total > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contratos') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contrato') }}
            span.pagina.espacamento-totalizador {{ formatNumber(totalizador) }} {{ totalizador > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorToneladas') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorTonelada') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )

    .modal-compartilhamento-relatorio
        ModalCompartilhamentoRelatorioRastreabilidade(
            ref='modalCompartilhamentoRelatorioRastreabilidade',
            :show='mostrarModalCompartilhamentoRelatorioRastreabilidade && isAlvorada',
            :numeroContrato='numeroContratoSelecionado',
            @enviarEmail='compartilharRelatorioRastreabilidadePorEmail',
            @voltar='mostrarModalCompartilhamentoRelatorioRastreabilidade = false'
        )
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ModalCompartilhamentoRelatorioRastreabilidade from './ModalCompartilhamentoRelatorioRastreabilidade.vue';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import formatters from '@/utils/formatters';

export default {
    name: 'TabelaGestaoContratoOriginacaoEmpresaAlvorada',
    components: {
        ModalCompartilhamentoRelatorioRastreabilidade
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        totalizador: {
            type: Number,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            notificacaoExportarRelatorio: null,
            notificacaoCompartilharRelatorio: null,
            codigosRemover: {
                NAO_VISUALIZADO: 'NAO_VISUALIZADO',
                CONCLUIDO: 'CONCLUIDO'
            },
            contratosSelecionados: [],
            mostrarModalCompartilhamentoRelatorioRastreabilidade: false,
            numeroContratoSelecionado: ''
        };
    },
    mounted() {},

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada'])
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarContratoOriginacaoEmpresa',
                params: { id: numeroContrato }
            });
        },
        editarContrato(numeroContrato) {
            this.$router.push({
                name: 'EditarContratoOriginacaoEmpresa',
                params: { id: numeroContrato }
            });
        },
        async exportarRelatorioRastreabilidade(numeroContrato) {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: 'Não foi possível realizar o download do pdf!'
                });
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/contrato-originacao/relatorio-rastreabilidade-empresa/pdf`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName = `relatorio-rastreabilidade-${numeroContrato}.pdf`;
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error({
                                    message:
                                        'Não foi possível exportar o relatório de rastreabilidade!'
                                });
                            }
                            if (this.notificacaoExportarRelatorio) {
                                this.notificacaoExportarRelatorio.close();
                            }
                            disconnect();
                        }
                    );

                    ContratoOriginacaoService.exportarPdfRelatorioRastreabilidadeEmpresa(
                        numeroContrato
                    );

                    this.notificacaoExportarRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i> O download do relatório está sendo processado!',
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error({
                        message: 'Não foi possível exportar o pdf!'
                    });
                    if (this.notificacaoExportarRelatorio) {
                        this.notificacaoExportarRelatorio.close();
                    }
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
                disconnect();
            }
        },
        exibirModalCompartilhamentoRelatorioRastreabilidade(numeroContrato) {
            this.numeroContratoSelecionado = numeroContrato;
            this.mostrarModalCompartilhamentoRelatorioRastreabilidade = true;
        },
        fecharNotificacaoCompartilharRelatorio() {
            if (this.notificacaoCompartilharRelatorio) {
                this.notificacaoCompartilharRelatorio.close();
            }
        },
        compartilharRelatorioRastreabilidadePorEmail(email) {
            try {
                ContratoOriginacaoService.compartilharRelatorioRastreabilidadeEmpresa(
                    this.numeroContratoSelecionado,
                    email
                ).then(() => {
                    this.fecharNotificacaoCompartilharRelatorio();
                    this.$notify.success({
                        message: 'Email enviado com sucesso!'
                    });
                });
                this.$refs.modalCompartilhamentoRelatorioRastreabilidade.fecharModal();
                this.notificacaoCompartilharRelatorio = this.$notify.info({
                    message:
                        '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i> O e-mail está sendo enviado!',
                    dangerouslyUseHTMLString: true
                });
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        },
        async removerContrato(contratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarRemocaoContrato'
                ) +
                    contratoOriginacao.numeroContrato +
                    '?',
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('removerContrato', contratoOriginacao.id);
            }
        },
        async arquivarContrato(idContratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarArquivamentoContrato'
                ),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('arquivarContrato', idContratoOriginacao);
            }
        },
        limparRemocao() {
            this.$refs.multipleTable.clearSelection();
        },
        handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.emiteRemoverContratoLote(idsContratosOriginacao);
        },
        emiteRemoverContratoLote(idsContratosOriginacao) {
            this.$emit('removerContratoLote', idsContratosOriginacao);
        },
        camposSelecionaveis(row, index) {
            const selecionavel =
                row.statusEmpresaCodigo === 'CONCLUIDO' ||
                row.statusEmpresaCodigo === 'NAO_VISUALIZADO';
            return selecionavel;
        },
        formatNumber(number, decimalPlaces) {
            return formatters.formatNumber(number, decimalPlaces);
        }
    }
};
</script>
<style lang="scss">
#tabela-gestao-contrato-originacao-empresa {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }
    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
    .status-processamento__dias {
        font-size: 12px;
        font-style: italic;
        i {
            margin-right: 2px;
        }
        .texto-alert {
            columns: #f88342;
        }
    }

    .espacamento-totalizador {
        margin-left: 20px;
    }
}
.el-message-box__btns {
    display: flex;
    justify-content: space-between;
}
</style>
